import { supabase } from './supabaseClient';

export const SUPPORT_TICKET_STATUSES = ['submitted', 'in_progress', 'resolved'];

export const SUPPORT_TICKET_CATEGORIES = [
  { value: 'general', label: 'General inquiry' },
  { value: 'technical', label: 'Technical issue' },
  { value: 'billing', label: 'Billing & payments' },
  { value: 'account', label: 'Account & access' },
  { value: 'device', label: 'Devices & sensors' },
  { value: 'account-deletion', label: 'Account Deletion Request' },
  { value: 'other', label: 'Other' },
];

function generateTicketNumber() {
  const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const suffix = Math.random().toString(36).slice(2, 6).toUpperCase();
  return `CV-${date}-${suffix}`;
}

async function requireUser() {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  if (!user) throw new Error('You must be logged in to manage support tickets.');
  return user;
}

function mapTicketRow(row) {
  if (!row) return row;
  return {
    id: row.id,
    ticketNumber: row.ticket_number,
    subject: row.subject,
    category: row.category,
    description: row.description,
    status: row.status,
    adminResponse: row.admin_response,
    resolvedAt: row.resolved_at,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
  };
}

export async function listSupportTickets() {
  await requireUser();

  const { data, error } = await supabase
    .from('support_tickets')
    .select('id, ticket_number, subject, category, description, status, admin_response, resolved_at, created_at, updated_at')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data || []).map(mapTicketRow);
}

export async function createSupportTicket({ subject, category, description }) {
  const user = await requireUser();

  const { data, error } = await supabase
    .from('support_tickets')
    .insert({
      user_id: user.id,
      ticket_number: generateTicketNumber(),
      subject: subject.trim(),
      category: category || 'general',
      description: description.trim(),
      status: 'submitted',
    })
    .select('id, ticket_number, subject, category, description, status, admin_response, resolved_at, created_at, updated_at')
    .single();

  if (error) throw error;
  return mapTicketRow(data);
}

export function getStatusLabel(status) {
  switch (status) {
    case 'in_progress':
      return 'In progress';
    case 'resolved':
      return 'Resolved';
    default:
      return 'Submitted';
  }
}

export function getStatusTagType(status) {
  switch (status) {
    case 'in_progress':
      return 'cyan';
    case 'resolved':
      return 'green';
    default:
      return 'blue';
  }
}
